export enum Notification {
    ERA_STATE_UPDATED_NOTIFICATION = "EraStateUpdatedNotification",
    TIME_ADVANCED = "TimeAdvancedNotification",
    RULER_NOTIFICATION = "RulerNotification",
}

export interface RulerNotification {
    timestamp: number
    message: string
}